function getGaotuUrl({path, query}) {
    const originUrl = window.location.origin;
    const originSplit = originUrl.split('-');
    const gaotuUrl = (originSplit.length > 1 ? `${originSplit[0]}-` : 'https://') + 'www.gaotu.cn';
    const urlPath = gaotuUrl + path;

    return setUrlParams(urlPath, query);
}

const setUrlParams = (url, data) => {
    if (!data) {
        return url;
    }
    let conj = '';

    const queryList = Object.entries(data).map(
        ([key, value]) =>{
            if (value) {
                return `${key}=${value}`
            }
        }
    );

    conj = url.indexOf('?') === -1 ? '?' : '&';

    return url + conj + queryList.join('&');
};

const parseUrl = (url) => {
    if (!url) {
        url = process.browser && location.href;
    }
    if (typeof url !== 'string') {
        return null;
    }
    const query = {};
    const paraArray = url.substring(url.indexOf('?') + 1).split('&');
    for (let i = 0, len = paraArray.length; i < len; i++) {
        const [key, value] = paraArray[i].split('=');
        query[key] = value;
    }
    return query;
};

export default {
    getGaotuUrl,
    setUrlParams,
	parseUrl
}
